import styled from '@emotion/styled';
import React from 'react';
import { theme } from 'styles/theme/theme';

interface InspectorSectionProps {
  title: string;
  children: React.ReactNode;
  /** Optional right-aligned control in the title row (e.g. an expand toggle). */
  headerAction?: React.ReactNode;
}

const InspectorSection: React.FC<InspectorSectionProps> = ({ title, children, headerAction }) => (
  <Root>
    <Header>
      <Title>{title}</Title>
      {headerAction}
    </Header>
    <Body>{children}</Body>
  </Root>
);

export default InspectorSection;

const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
`;

const Root = styled.section`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding-bottom: 12px;
  border-bottom: 1px solid ${theme.colors.DarkBlue100};

  &:last-of-type {
    border-bottom: none;
  }
`;

const Title = styled.h4`
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: ${theme.colors.Gray};
  margin: 0;
`;

const Body = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;
